import { Model } from '@shared/models/model';
import { Expose } from 'class-transformer';

export class WCCDeliveryNoteLine extends Model {
  @Expose()
  shortDesc: string;

  @Expose()
  desc: string;

  @Expose()
  orderAmount: number;

  @Expose()
  loadedAmount: number;

  @Expose()
  unitMeasurement: string;

  @Expose()
  loadingRemark: string;

  @Expose()
  deliveryLineId: number;

  @Expose()
  productId: number;

  @Expose()
  deletedFlag: string;
}
